import { useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Plus, FileText, User, Car, Calendar, Package, ReceiptText, Truck, CreditCard } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Role-aware quick create actions
const ACTIONS_BY_ROLE = {
  owner: [
    { key: "job_card", label: "New Job Card", Icon: FileText, url: "/job-cards/new" },
    { key: "appointment", label: "New Appointment", Icon: Calendar, url: "/appointments?new=1" },
    { key: "customer", label: "New Customer", Icon: User, url: "/customers?new=1" },
    { key: "vehicle", label: "New Vehicle", Icon: Car, url: "/vehicles?new=1" },
    { key: "estimate", label: "New Estimate", Icon: ReceiptText, url: "/estimates/new" },
    { key: "inventory", label: "New Inventory Item", Icon: Package, url: "/inventory?new=1" },
    { key: "payment", label: "Record Payment", Icon: CreditCard, url: "/invoices" },
  ],
  branch_manager: [
    { key: "job_card", label: "New Job Card", Icon: FileText, url: "/job-cards/new" },
    { key: "appointment", label: "New Appointment", Icon: Calendar, url: "/appointments?new=1" },
    { key: "customer", label: "New Customer", Icon: User, url: "/customers?new=1" },
    { key: "estimate", label: "New Estimate", Icon: ReceiptText, url: "/estimates/new" },
    { key: "payment", label: "Record Payment", Icon: CreditCard, url: "/invoices" },
  ],
  advisor: [
    { key: "job_card", label: "New Job Card", Icon: FileText, url: "/job-cards/new" },
    { key: "appointment", label: "New Appointment", Icon: Calendar, url: "/appointments?new=1" },
    { key: "customer", label: "New Customer", Icon: User, url: "/customers?new=1" },
    { key: "vehicle", label: "New Vehicle", Icon: Car, url: "/vehicles?new=1" },
    { key: "payment", label: "Record Payment", Icon: CreditCard, url: "/invoices" },
  ],
  mechanic: [
    { key: "add_finding", label: "Add Finding", Icon: FileText, url: "/my-jobs" },
  ],
  storekeeper: [
    { key: "receive_stock", label: "Receive Stock", Icon: Package, url: "/inventory?receive=1" },
    { key: "inventory", label: "New Inventory Item", Icon: Package, url: "/inventory?new=1" },
  ],
  cashier: [
    { key: "payment", label: "Record Payment", Icon: CreditCard, url: "/invoices" },
  ],
  accountant: [
    { key: "payment", label: "Record Payment", Icon: CreditCard, url: "/invoices" },
  ],
  driver: [],
};

export default function QuickCreateMenu() {
  const nav = useNavigate();
  const { user } = useAuth();
  const role = user?.role || "owner";
  const actions = ACTIONS_BY_ROLE[role] || ACTIONS_BY_ROLE.owner;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="quick-create-btn"
          type="button"
          className="inline-flex items-center gap-1.5 h-9 px-3 rounded-lg bg-[#e63946] text-white text-[13px] font-semibold hover:bg-[#d02f3c] focus:outline-none focus:ring-2 focus:ring-[#e63946]/40 transition-colors"
        >
          <Plus size={15} strokeWidth={2.5} />
          <span className="hidden sm:inline">Create</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-56 rounded-lg bg-white border border-[#E4E7EC] shadow-lg p-1"
      >
        <DropdownMenuLabel className="text-[11px] uppercase tracking-wider text-[#1d3557] font-bold px-2 py-1.5">
          Quick create
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-[#E4E7EC]" />
        {actions.map(({ key, label, Icon, url }) => (
          <DropdownMenuItem
            key={key}
            data-testid={`quick-create-${key}`}
            onClick={() => nav(url)}
            className="cursor-pointer rounded-md text-[13px] text-[#1d3557] font-semibold hover:bg-[#F1FAEE] focus:bg-[#F1FAEE] hover:!text-[#1d3557] focus:!text-[#1d3557] data-[highlighted]:!text-[#1d3557] data-[highlighted]:bg-[#F1FAEE] px-2 py-2 flex items-center gap-2"
          >
            <Icon size={15} className="text-[#457b9d]" />
            {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
